import { HTTP, authHeader } from './http-service';

class PropertyCheckerUserService {
  get() {
    return HTTP.get(`/PropertyCheckerUser/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  byEmail(accountId) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';

    return HTTP.post(`/PropertyCheckerUser/byemail?accountId=${accountId}`, `"${accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  invite(payload) {
    return HTTP.post(`/PropertyCheckerUser/invite/`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  resendInvite(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.post(
      `/PropertyCheckerUser/sendInvite?email=${payload.accountId}`,
      `"${payload.accountId}"`,
      {
        headers,
      }
    ).then((response) => {
      return response.data;
    });
  }

  disable(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.put(`/PropertyCheckerUser/disable?email=${payload.accountId}`, `"${payload.accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  enable(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.put(`/PropertyCheckerUser/enable?email=${payload.accountId}`, `"${payload.accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }
}

export default new PropertyCheckerUserService();
